import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./styles.scss";

gsap.registerPlugin(ScrollTrigger);

const styles = {
  transparentBright: {
    header: { backgroundColor: "#00000000", color: "white", boxShadow: "none" },
    icons: { fill: "white" },
    // forTeslaNav
    links: { color: "white" },
  },
  transparentDark: {
    header: { backgroundColor: "#ffffff00", color: "#686869", boxShadow: "none" },
    icons: { fill: "#686869" },
    // forTeslaNav
    links: { color: "#ca6710" },
  },
  dark: {
    header: { backgroundColor: "#000000ff", color: "#333333", boxShadow: "none" },
    icons: { fill: "white" },
    // forTeslaNav
    links: { color: "#333333" },
  },
  bright: {
    header: { backgroundColor: "#ffffffff", color: "#333333", boxShadow: "0 0 10px rgba(0,0,0,.1)" },
    icons: { fill: "#333333" },
    // forTeslaNav
    links: { color: "#333333" },
  },
};

class ToggleFixedNavbarStyles {
  constructor() {
    this.currentStyle = "";
    this.DOM = { navSelectors: "#desktop-nav, #offcanvas-nav" };
    this.DOM.toggleSelector = "[data-navtog]";
    this.DOM.header = document.getElementById("page-header");
    // Added for Tesla -> not in ideas yet
    this.DOM.outstandingNavLinks = [...this.DOM.header.querySelectorAll(".navbar-nav a")];
    this.DOM.trigger = [...document.querySelectorAll("[data-navtog]")];
    this.initialStyleName = this.DOM.trigger[0].dataset.navtog;
    this.DOM.navis = document.querySelectorAll[this.DOM.navSelectors];
    this.headerHeight = this.getHeaderHeight();
    this.scrollTriggers = [];
    this.timelines = [];
    this.initScrollTriggers();
  }
  setInitialStyle = () => {
    if (window.scrollY < 50) {
      gsap.set(this.DOM.header, styles[this.initialStyleName].header);
      gsap.set(this.DOM.outstandingNavLinks, styles[this.initialStyleName].links);
      gsap.set(this.DOM.header.querySelectorAll("svg"), styles[this.initialStyleName].icons);
    } else {
      gsap.set(this.DOM.outstandingNavLinks, styles[this.initialStyleName].links);
      gsap.set(this.DOM.header, styles[this.initialStyleName].header);
      gsap.set(this.DOM.header.querySelectorAll("svg"), styles[this.initialStyleName].icons);
    }
  };
  getHeaderHeight = () => this.DOM.header.offsetHeight;
  initScrollTriggers = () => {
    this.DOM.trigger.forEach((trigger, index) => {
      const styleName = trigger.dataset.navtog;
      const tl = gsap
        .timeline({
          id: index,
          paused: true,
          defaults: {
            duration: 0.35,
          },
        })
        .to(this.DOM.outstandingNavLinks, styles[styleName].links)
        .to(this.DOM.header, styles[styleName].header, 0)
        .to(this.DOM.header.querySelectorAll("svg"), styles[styleName].icons, 0);
      const st = ScrollTrigger.create({
        trigger,
        markers: false,
        start: () => "top " + this.headerHeight,
        end: () => "bottom " + this.headerHeight,
        onEnter: () => {
          if (this.currentStyle === styleName) return;
          tl.restart();
          this.currentStyle = styleName;
        },
        onEnterBack: () => {
          if (this.currentStyle === styleName) return;
          tl.restart();
          this.currentStyle = styleName;
        },
      });
      this.scrollTriggers.push(st);
      this.timelines.push(tl);
    });
  };
  destroy = () => {
    this.scrollTriggers.forEach((st) => st.kill);
    this.timelines.forEach((tl) => tl.kill());
    this.scrollTriggers = this.timelines = [];
  };
}

export { ToggleFixedNavbarStyles };
